import ProfileInstitutionSection from "./profile-institution-section";

export default ProfileInstitutionSection;
